module.exports = __webpack_public_path__ + "static/img/v2.8eb4d983.png";